import type {
  StoreClockPayload,
  StoreClockResponse,
  StoreContactCallPayload,
  StoreContactCallResponse,
  StoreProcessTaskCreatePayload,
  StoreProcessTaskResponse,
  StoreProcessTaskUpdatePayload,
  StoreTaskCompletionPayload,
  StoreTaskCompletionResponse,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

// store-app : la boutique valide une tâche « process » depuis le dashboard (guard `store`)
export const setStoreProcessTaskCompletion = async ({
  id,
  ...payload
}: StoreTaskCompletionPayload & { id: number }): Promise<StoreTaskCompletionResponse> => {
  const response = await gozokiApiWithAuth.patch<StoreTaskCompletionResponse>(
    `/store/process-tasks/${id}/completion`,
    payload,
  )
  return response.data
}

// back-office : planifie une tâche « process » pour une boutique (guard `admin`)
export const createStoreProcessTask = async (
  payload: StoreProcessTaskCreatePayload,
): Promise<StoreProcessTaskResponse> => {
  const response = await gozokiApiWithAuth.post<StoreProcessTaskResponse>(
    '/store-process-tasks',
    payload,
  )
  return response.data
}

// back-office : édite une tâche « process » déjà planifiée (guard `admin`)
export const updateStoreProcessTask = async ({
  id,
  data,
}: {
  id: number
  data: StoreProcessTaskUpdatePayload
}): Promise<StoreProcessTaskResponse> => {
  const response = await gozokiApiWithAuth.patch<StoreProcessTaskResponse>(
    `/store-process-tasks/${id}`,
    data,
  )
  return response.data
}

// back-office : supprime une tâche « process » (guard `admin`)
export const deleteStoreProcessTask = async (id: number): Promise<{ success: true }> => {
  const response = await gozokiApiWithAuth.delete<{ success: true }>(`/store-process-tasks/${id}`)
  return response.data
}

// store-app : journalise un appel de contact passé depuis la tablette boutique (guard `store`)
export const logStoreContactCall = async (
  payload: StoreContactCallPayload,
): Promise<StoreContactCallResponse> => {
  const response = await gozokiApiWithAuth.post<StoreContactCallResponse>(
    '/store/contact-call',
    payload,
  )
  return response.data
}

// store-app : pointage kiosk (clock-in/out) avec photo témoin (multipart, guard `store`)
export const storeClock = async (payload: StoreClockPayload): Promise<StoreClockResponse> => {
  const form = new FormData()
  form.append('collaboratorId', String(payload.collaboratorId))
  form.append('action', payload.action)
  form.append('workShiftId', String(payload.workShiftId))
  form.append('temoinFile', payload.temoinFile, 'temoin.jpg')
  const response = await gozokiApiWithAuth.post<StoreClockResponse>('/store/clock', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}
